import {
  FormControl,
  InputLabel,
  ListItem,
  MenuItem,
  Select,
  CircularProgress,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect } from "react";
import { Cantiere, getCantieri } from "../../service/cantieri";
import { useOperatori } from "../../service/operatori";

const FiltroOperatore = ({

  onSelectOperatore = (selected) => {}

} : {

  onSelectOperatore: (selected: string | null) => any

}) => {

  const operatori = useOperatori({}); 

  return (
    <ListItem key={"Operatore"}> 
      <FormControl fullWidth>
        <InputLabel id="select-operatore-label">Operatore</InputLabel>
        {operatori.isLoading === true ? (
          <CircularProgress />
        ) : (
          <Select
            labelId="select-operatore-label"
            id="select-operatore"
            label="Operatore"
            onChange={(selected: any) => { 
              onSelectOperatore(selected.target.value.toString()); 
          }}>
            {operatori.results.map((operatore, key) => (
              <MenuItem key={key} value={operatore.idoperatorecantiere ? operatore.idoperatorecantiere : ""}>
                {operatore.nomecognome}
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
    </ListItem>
  );
};

export default FiltroOperatore;
